class ExpansionPanel {
    private panelsHeaders: NodeListOf<HTMLElement>;

    constructor() {
        this.panelsHeaders = document.querySelectorAll('.expansion-panel__header');
        this.initialize();
    }

    private initialize(): void {
        if (this.panelsHeaders) {
            this.panelsHeaders.forEach(header => {
                header.addEventListener('click', this.handleHeaderClick.bind(this));
            });
        }
    }

    private handleHeaderClick(event: Event): void {
        const header = event.currentTarget as HTMLElement;
        const content = header.nextElementSibling as HTMLElement;
        
        header.classList.toggle('expansion-panel__header--active');
        content.classList.toggle('expansion-panel__content--active');
    }

    private onFormValidateField(): void {
        console.log('onFormValidateField executed!');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new ExpansionPanel();
});